import { FC } from 'react';
import { cn } from '../utils';

type CourseThumbnailProps = {
  thumbnail?: string | null;
  size?: 'sm' | 'md' | 'lg';
};

const sizeMap = {
  sm: 'lf:w-12',
  md: 'lf:w-16',
  lg: 'lf:w-[4.5rem]',
};

const imageSizeMap = {
  sm: 48,
  md: 64,
  lg: 72,
};

export const CourseThumbnail: FC<CourseThumbnailProps> = ({
  thumbnail,
  size = 'sm',
}) => {
  return (
    <div
      className={cn(
        'lf:aspect-video lf:shrink-0 lf:rounded-md lf:bg-neutral-100',
        sizeMap[size],
      )}
    >
      {thumbnail && (
        <img
          src={thumbnail}
          alt=""
          width={imageSizeMap[size]}
          className="lf:shrink-0 lf:rounded-md lf:bg-neutral-100 lf:object-cover"
        />
      )}
    </div>
  );
};
